export const colorBox = {
    scale: [{
        moduleType: 'GROUP',
        title: '当月入组数/当年累计入组数',
        backgroundImage: 's1',
        showCompare: true,
        toType: 'MONTH_GROUP',
    }, {
        moduleType: 'IN_GROUP',
        title: '当月在组情况',
        backgroundImage: 's2',
        showCompare: true,
        toType: 'MONTH_IN_GROUP',
    }, {
        moduleType: 'CRC_FTE',
        title: '当月CRC消耗FTE',
        backgroundImage: 's3',
        showCompare: true,
        toType: 'MONTH_CRC_FTE',
    }, {
        moduleType: 'NEW_SITE',
        title: '当月启动中心数/当年累计启动中心数',
        backgroundImage: 's4',
        showCompare: true,
        toType: 'MONTH_NEW_SITE',
    }, {
        moduleType: 'PROJECT_NUM',
        title: '当月进行中项目数量/历年项目数量',
        backgroundImage: 's5',
        showCompare: true,
        toType: 'MONTH_PROJECT_NUM',
    }, {
        moduleType: 'STOP_PROJECT_NUM',
        title: '当月结束项目数量',
        backgroundImage: 's6',
        showCompare: false,
        toType: 'MONTH_PROJECT_NUM',
    }, {
        moduleType: 'VISIT_AMOUNT',
        title: '当月访视数/当年累计访视数',
        backgroundImage: 's7',
        showCompare: true,
        toType: 'MONTH_VISIT_AMOUNT',
    }, {
        moduleType: 'STANDARD_VISIT_AMOUNT',
        title: '当月已确认标准访视数/当年累计已确认标准访视数',
        backgroundImage: 's8',
        showCompare: true,
        toType: 'MONTH_STANDARD_VISIT_AMOUNT',
    }],
    efficiency: [{
        moduleType: 'UNITS_FTE_GROUP',
        title: '单位FTE入组数',
        backgroundImage: 'e1',
        showCompare: true,
        toType: 'MONTH_UNITS_FTE_GROUP',
    }, {
        moduleType: 'UNITS_FTE_VISIT',
        title: '单位FTE访视数',
        backgroundImage: 'o2',
        showCompare: true,
        toType: 'MONTH_UNITS_FTE_VISIT',
    }, {
        moduleType: 'UNITS_FTE_STANDARD_VISIT',
        title: '单位FTE标准访视数',
        backgroundImage: 'e4',
        showCompare: true,
        toType: 'MONTH_UNITS_FTE_STANDARD_VISIT',
    }, {
        moduleType: 'PER_RANDOM_AMOUNT',
        title: '人均入组数',
        backgroundImage: 'e2',
        showCompare: true,
        allBusiness: true,
        toType: 'MONTH_PER_RANDOM_AMOUNT',
    }, {
        moduleType: 'PER_VISIT_AMOUNT',
        title: '人均访视数',
        backgroundImage: 'e3',
        showCompare: true,
        allBusiness: true,
        toType: 'MONTH_PER_VISIT_AMOUNT',
    }, {
        moduleType: 'PER_STANDARD_VISIT_AMOUNT',
        title: '人均确认标准访视数',
        backgroundImage: 'e4',
        showCompare: true,
        allBusiness: true,
        toType: 'MONTH_PER_STANDARD_VISIT_AMOUNT',
    }],
    operationMonitor: [{
        moduleType: 'MONITOR_SITE_START_TIME',
        title: '当月平均启动时长',
        backgroundImage: 'o1',
        reversal: true,
        showCompare: true,
        toType: 'MONITOR_SITE_START_GLOBAL',
    }, {
        moduleType: 'REQUIREMENT_SATISFIED',
        title: '当月需求满足率（当月需求满足量/当月需求总量）',
        backgroundImage: 'o2',
        showCompare: true,
        toType: 'REQUIREMENT_SATISFIED_GLOBAL',
    }, {
        moduleType: 'REQUIREMENT_FTE',
        title: '当月已处理需求的FTE/当月待处理需求的FTE',
        backgroundImage: 'o3',
        showCompare: false,
        toType: 'REQUIREMENT_FTE_GLOBAL',
    }, {
        moduleType: 'MAJOR_EVENT',
        title: '当月重大事件发生数/当年累计重大事件数',
        backgroundImage: 'o4',
        reversal: true,
        showCompare: true,
        toType: 'MONTH_MAJOR_EVENT',
    }, {
        moduleType: 'MAJOR_EVENT_RATE',
        title: '当年重大事件发生率（当年累计重大事件数/当年累计完成访视数）',
        backgroundImage: 'o5',
        reversal: true,
        showCompare: true,
        toType: 'MONTH_MAJOR_EVENT_RATE',
    }],
    scheduleVariance: [{
        moduleType: 'PA_RANDOM_AMOUNT',
        title: '当月计划入组数/当月实际入组数',
        backgroundImage: 'o1',
        showCompare: true,
        toType: 'PLAN_RANDOM_AMOUNT',
    }, {
        moduleType: 'PA_VISIT_AMOUNT',
        title: '当月计划访视数/当月完成访视数',
        backgroundImage: 'o2',
        showCompare: true,
        toType: 'PLAN_VISIT_AMOUNT',
    }, {
        moduleType: 'PA_SITE_START',
        title: '当月计划启动数/当月实际启动数',
        backgroundImage: 'o3',
        showCompare: true,
        toType: 'PLAN_SITE_START',
    }, {
        moduleType: 'PA_FTE',
        title: '当月CRC计划FTE/当月CRC消耗FTE',
        backgroundImage: 'o4',
        showCompare: true,
        toType: 'PLAN_FTE',
    }, {
        moduleType: 'INV_PLAN_FTE_PROGRESS_DIFF_COLOR',
        title: '当月项目计划FTE/当月项目确认FTE',
        backgroundImage: 'o5',
        showCompare: true,
        toType: 'INV_PLAN_FTE_PROGRESS_DIFF_GRAPH',
    }],
};

export const chartBox = {
    scale: [{
        moduleType: 'MONTH_GROUP',
        title: '每月入组情况',
        tips:  '当月入组数/当年累计入组数',
        chartTypes: ['column', 'line'],
        toType: 'MONTH_GROUP',
        dataType:"amount",
    }, {
        moduleType: 'MONTH_IN_GROUP',
        title: '每月在组数',
        tips:  '每月25号24点“试验进行中”的患者数',
        chartTypes: ['line'],
        toType: 'MONTH_IN_GROUP',
        dataType:"amount",
    }, {
        moduleType: 'MONTH_CRC_FTE',
        title: '每月CRC消耗FTE',
        tips:  '每月产生的CRC项目确认FTE',
        chartTypes: ['column', 'line'],
        toType: 'MONTH_CRC_FTE',
        dataType:"rate",
    }, {
        moduleType: 'MONTH_NEW_SITE',
        title: '每月启动中心数',
        tips: '每月启动中心数/当年累计启动中心数',
        chartTypes: ['column', 'line'],
        toType: 'MONTH_NEW_SITE',
        dataType:"rate",
    }, {
        moduleType: 'MONTH_PROJECT_NUM',
        title: '每月项目数量情况',
        tips:  '每月进行中项目数/每月结束项目数/每月所有项目数',
        chartTypes: ['column', 'line'],
        toType: 'MONTH_PROJECT_NUM',
        dataType:"amount",
    }, {
        moduleType: 'MONTH_VISIT_AMOUNT',
        title: '每月完成访视数',
        tips:  '每月完成访视数/每月累计完成访视数',
        chartTypes: ['column', 'line'],
        toType: 'MONTH_VISIT_AMOUNT',
          dataType:"amount",
    }, {
        moduleType: 'MONTH_STANDARD_VISIT_AMOUNT',
        title: '每月已确认标准访视数',
        tips:  '每月已确认标准访视数/每月累计已确认标准访视数',
        chartTypes: ['column', 'line'],
        toType: 'MONTH_STANDARD_VISIT_AMOUNT',
        dataType:"dAmount",
    }, {
        moduleType: 'IN_PROGRESS_PROJECT',
        title: '进行中项目占比',
        chartTypes: ['pie'],
        projectDimension: ['INVESTIGATION_AREA', 'INVESTIGATION_STAGE', 'IS_SINGLE', 'INVESTIGATION_BY_STAGE'],
        toType: 'MONTH_PROJECT_NUM',
    }, {
        moduleType: 'CALENDAR_PROJECT_NUM',
        title: '历年项目占比',
        chartTypes: ['pie'],
        projectDimension: ['INVESTIGATION_AREA', 'INVESTIGATION_BY_STAGE'],
        toType: 'MONTH_PROJECT_NUM',
    }, {
        moduleType: 'TYPE_VISIT_AMOUNT',
        title: '每月完成访视类型占比',
        chartTypes: ['pie'],
        //toType: 'TYPE_VISIT_AMOUNT',
    }],
    efficiency: [{
        moduleType: 'MONTH_UNITS_FTE_GROUP',
        title: '每月单位FTE入组数',
        tips: "每月入组数/每月CRC消耗FTE",
        chartTypes: ['line'],
        toType: 'MONTH_UNITS_FTE_GROUP',
        dataType:"rate",
    }, {
        moduleType: 'MONTH_UNITS_FTE_VISIT',
        title: '每月单位FTE访视数',
        showCompare: true,
        chartTypes: ['line'],
        toType: 'MONTH_UNITS_FTE_VISIT',
        dataType:"rate",
    }, {
        moduleType: 'MONTH_UNITS_FTE_STANDARD_VISIT',
        title: '每月单位FTE标准访视数',
        showCompare: true,
        chartTypes: ['line'],
        toType: 'MONTH_UNITS_FTE_STANDARD_VISIT',
        dataType:"rate",
    }, {
        moduleType: 'MONTH_PER_RANDOM_AMOUNT',
        title: '每月人均入组数',
        tips: "每月入组数/每月城市人数",
        chartTypes: ['line'],
        toType: 'MONTH_PER_RANDOM_AMOUNT',
        dataType:"rate",
        allBusiness: true,
    }, {
        moduleType: 'MONTH_PER_VISIT_AMOUNT',
        title: '每月人均访视数',
        tips: "每月访视数/每月城市人数",
        chartTypes: ['line'],
        toType: 'MONTH_PER_VISIT_AMOUNT',
        dataType:"rate",
        allBusiness: true,
    }, {
        moduleType: 'MONTH_PER_STANDARD_VISIT_AMOUNT',
        title: '每月人均确认标准访视数',
        tips: "每月人均确认标准访视数/每月城市人数",
        chartTypes: ['line'],
        toType: 'MONTH_PER_STANDARD_VISIT_AMOUNT',
        dataType:"rate",
        allBusiness: true,
    }],
    operationMonitor: [{
        moduleType: 'MONITOR_SITE_START_GLOBAL',
        title: '每月平均启动时长',
        tips: "每月新启动中心数的启动时长平均值",
        chartTypes: ['column'],
        valueProps: { column: 'siteStartTime' },
        toType: 'MONITOR_SITE_START_GLOBAL',
        dataType:"rate",
    }, {
        moduleType: 'REQUIREMENT_SATISFIED_GLOBAL',
        title: '每月需求满足率',
        tips: "每月满足需求数量/每月需求总量",
        chartTypes: ['column', 'line'],
        toType: 'REQUIREMENT_SATISFIED_GLOBAL',
        dataType:"rate",
    }, {
        moduleType: 'REQUIREMENT_FTE_GLOBAL',
        title: '每月需求处理的FTE情况',
        tips: "当月已处理需求的FTE/当月待处理需求的FTE",
        chartTypes: ['column'],
        valueProps: { column: 'rate' },
        toType: 'REQUIREMENT_FTE_GLOBAL',
        dataType:"rate",
    }, {
        moduleType: 'MONTH_MAJOR_EVENT',
        title: '每月重大事件发生数',
        tips: "每月重大事件发生数/累计重大事件数",
        chartTypes: ['column', 'line'],
        toType: 'MONTH_MAJOR_EVENT',
        dataType:"amount",
    }, {
        moduleType: 'MONTH_MAJOR_EVENT_RATE',
        title: '每月重大事件发生率',
        tips: "当年重大事件发生率=当年累计重大事件数/当年累计完成访视数",
        chartTypes: ['column', 'line'],
        toType: 'MONTH_MAJOR_EVENT_RATE',
        dataType:"rate",
    }],
    scheduleVariance: [{
        moduleType: 'PLAN_RANDOM_AMOUNT',
        title: '每月计划入组数',
        tips: "每月计划入组数/每月实际入组数",
        chartTypes: ['column', 'line'],
        toType: 'PLAN_RANDOM_AMOUNT',
        dataType:"amount",
    }, {
        moduleType: 'PLAN_VISIT_AMOUNT',
        title: '每月计划访视数',
        tips: "每月计划访视数/每月完成访视数",
        chartTypes: ['column', 'line'],
        toType: 'PLAN_VISIT_AMOUNT',
        dataType:"amount",
    }, {
        moduleType: 'PLAN_SITE_START',
        title: '每月计划启动数',
        tips: "每月计划启动数/每月实际启动数",
        chartTypes: ['column', 'line'],
        toType: 'PLAN_SITE_START',
        dataType:"amount",
    }, {
        moduleType: 'PLAN_FTE',
        title: '每月CRC计划FTE',
        tips: "每月CRC计划FTE/每月CRC消耗FTE",
        chartTypes: ['column', 'line'],
        toType: 'PLAN_FTE',
        dataType:"rate",
    }, {
        moduleType: 'INV_PLAN_FTE_PROGRESS_DIFF_GRAPH',
        title: '每月项目计划FTE',
        tips: "每月项目计划FTE/每月项目消耗FTE",
        chartTypes: ['column', 'line'],
        toType: 'INV_PLAN_FTE_PROGRESS_DIFF_GRAPH',
        dataType:"rate",
    }]
}

export const ColorParams = {
    lineOfBusiness: -1,
    statisticalRange: 'SITE',
    areaName: '全国',
    hasCheckedArea: ['COUNTRY_0'],
    areaParams: { 'params[全国]': 'COUNTRY_0'},
}
export const ChartParams = {
    displayType: 'All',
    lineOfBusiness: -1,
    statisticalRange: 'SITE',
    analysisDimension: 'GLOBAL'
};

export const PieChartParams = {
    lineOfBusiness: -1,
    statisticalRange: 'SITE',
    analysisDimension: 'GLOBAL'
};

export const DefaultParams = {
    scale: {
        statisticalRange: 'SITE',
    }, 
    efficiency: {
        statisticalRange: 'SITE',
    }, 
    operationMonitor: {
        statisticalRange: 'SITE',
    },
    scheduleVariance: {
        statisticalRange: 'SITE',
    },
};


// WEBPACK FOOTER //
// ./src/components/homePage/constants/project.js